import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { appBootstrapService } from './services/AppBootstrapService';
import { appUpdateService } from './services/AppUpdateService';

const startApplication = async (): Promise<void> => {
  // La configuración remota debe resolverse antes de importar App, ya que los
  // servicios Firebase se inicializan durante la carga de sus módulos.
  await appBootstrapService.initialize();
  const { default: App } = await import('./App');

  ReactDOM.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
    document.getElementById('root')
  );

  serviceWorkerRegistration.register({
    onUpdate: registration => appUpdateService.handleServiceWorkerUpdate(registration)
  });
  appUpdateService.start();
  reportWebVitals();
};

const renderBootstrapError = (): void => {
  const root = document.getElementById('root');
  if (!root) return;

  const container = document.createElement('main');
  container.style.cssText = 'min-height:100vh;display:flex;align-items:center;justify-content:center;padding:24px;background:#f5fafc;font-family:Inter,Arial,sans-serif;color:#102a3a;box-sizing:border-box';
  const card = document.createElement('section');
  card.style.cssText = 'max-width:520px;padding:28px;border:1px solid #c9dce3;border-radius:18px;background:#fff;text-align:center;box-shadow:0 12px 34px rgba(16,42,58,.12)';
  const title = document.createElement('h1');
  title.textContent = 'No fue posible cargar esta aplicación';
  title.style.cssText = 'margin:0 0 12px;font-size:24px';
  const description = document.createElement('p');
  description.textContent = 'Verifique su conexión e intente nuevamente. La configuración de este despliegue no está disponible todavía.';
  description.style.cssText = 'margin:0 0 20px;line-height:1.5;color:#58717e';
  const retry = document.createElement('button');
  retry.type = 'button';
  retry.textContent = 'Intentar nuevamente';
  retry.style.cssText = 'padding:12px 18px;border:0;border-radius:10px;background:#087e98;color:#fff;font-weight:700;cursor:pointer';
  retry.addEventListener('click', () => window.location.reload());
  card.appendChild(title);
  card.appendChild(description);
  card.appendChild(retry);
  container.appendChild(card);
  while (root.firstChild) root.removeChild(root.firstChild);
  root.appendChild(container);
};

void startApplication().catch(error => {
  console.error('No se pudo iniciar la aplicación.', error);
  renderBootstrapError();
});
